export const GET_RULES_CONDITIONS_REQUEST = 'GET_RULES_CONDITIONS_REQUEST';
export const GET_RULES_CONDITIONS_SUCCESS = 'GET_RULES_CONDITIONS_SUCCESS';
export const GET_RULES_CONDITIONS_ERROR = 'GET_RULES_CONDITIONS_ERROR';
export const ADD_RULES_CONDITION_REQUEST = 'ADD_RULES_CONDITION_REQUEST';
export const ADD_RULES_CONDITION_SUCCESS = 'ADD_RULES_CONDITION_SUCCESS';
export const ADD_RULES_CONDITION_ERROR = 'ADD_RULES_CONDITION_ERROR';
export const GET_RULES_CONDITION_REQUEST = 'GET_RULES_CONDITION_REQUEST';
export const GET_RULES_CONDITION_SUCCESS = 'GET_RULES_CONDITION_SUCCESS';
export const GET_RULES_CONDITION_ERROR = 'GET_RULES_CONDITION_ERROR';
export const UPDATE_RULES_CONDITION_REQUEST = 'UPDATE_RULES_CONDITION_REQUEST';
export const UPDATE_RULES_CONDITION_SUCCESS = 'UPDATE_RULES_CONDITION_SUCCESS';
export const UPDATE_RULES_CONDITION_ERROR = 'UPDATE_RULES_CONDITION_ERROR';
export const DELETE_RULES_CONDITION_REQUEST = 'DELETE_RULES_CONDITION_REQUEST';
export const DELETE_RULES_CONDITION_SUCCESS = 'DELETE_RULES_CONDITION_SUCCESS';
export const DELETE_RULES_CONDITION_ERROR = 'DELETE_RULES_CONDITION_ERROR';
export const UPDATE_RULES_CONDITIONS_PAGINATION_PARAMS =
  'UPDATE_RULES_CONDITIONS_PAGINATION_PARAMS';
